import { deepEqual } from 'fast-equals';
import { useEffect, useMemo, useRef } from 'react';
import { autofillValues } from '../../components/form/autofill';
import { fillEmptyValues } from '../form-values';
import { normalizeValues } from './normalize-values';
export const useFormValues = (form, values, onChange, config, enableAutofill) => {
  const hasAutofilled = useRef(false);
  const normalizedValues = useMemo(() => {
    let filled = fillEmptyValues(form, values);
    if (enableAutofill && !hasAutofilled.current && config != null && config.userData) {
      hasAutofilled.current = true;
      filled = autofillValues(form, filled, config);
    }
    return normalizeValues(form, filled, true, config);
  }, [form, values, config, enableAutofill]);
  useEffect(() => {
    const hasAnyValueChanged = !deepEqual(normalizedValues, values);
    if (hasAnyValueChanged) {
      onChange == null || onChange(normalizedValues);
    }
  }, [values, normalizedValues, onChange]);
  return normalizedValues;
};
//# sourceMappingURL=use-form-values.js.map